module.exports = __webpack_public_path__ + "img/logo.93eb1e13.png";